<template>
  <v-container fluid class="deleted-customer-page pa-0">
    <v-card :loading="loading" outlined class="deleted-customer-card">
      <div class="list-header">
        <div class="title-wrap">
          <v-btn icon small class="mr-2" @click="$router.go(-1)">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>

          <div>
            <div class="page-title">Deleted Customers</div>
            <div class="page-subtitle">
              {{ customers.length }} customer{{ customers.length === 1 ? "" : "s" }} found
            </div>
          </div>
        </div>
      </div>

      <div class="filter-bar">
        <v-text-field
          v-model="search"
          outlined
          prepend-inner-icon="mdi-magnify"
          dense
          label="Search customers"
          single-line
          hide-details
          clearable
          class="search-field"
        />
      </div>

      <v-card-text class="pa-4">
        <v-data-table
          :mobile-breakpoint="0"
          :headers="headers"
          :items="customers"
          :search="search"
          :loading="loading"
          :sort-by="sortBy"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          class="deleted-customer-table"
        >
          <template v-slot:item="{ item }">
            <tr class="pointer table-row">
              <td class="text-left">
                <div class="font-weight-bold">{{ item.name }}</div>
              </td>

              <td class="text-left">
                {{ item.contactName || "--" }}
              </td>

              <td class="text-left">
                {{ item.cellNumber || "--" }}
              </td>

              <td class="text-left">
                <v-chip small color="red lighten-5" text-color="red darken-3" class="font-weight-bold">
                  {{ item.deletedAt | moment("MM/DD/YYYY") }}
                </v-chip>
              </td>

              <td class="text-left font-weight-bold">
                <span v-if="checkRightStatus(33)">
                  {{ item.balance | currency }}
                </span>
                <span v-else>--</span>
              </td>

              <td class="text-right">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon small>
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list dense class="menu-button">
                    <v-list-item
                      v-if="checkRightStatus(23)"
                      @click="unDeletedCustomer(item)"
                    >
                      <v-list-item-title>Restore Customer</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>

          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import customerService from "../service.js";
// import DeleteCustomer from "../components/DeleteCustomer";

export default {
  data() {
    return {
      createDialog: false,
      editDialog: false,
      selectedCustomer: null,
      headers: [
        {
          text: "Business Name",
          value: "name",
          sortable: true,
          align: "left",
        },
        {
          text: "Contact Name",
          value: "contactName",
          align: "left",
          sortable: true,
        },
        {
          text: "Cell Number",
          value: "cellNumber",
          align: "left",
          sortable: true,
        },
        {
          text: "Deleted At",
          value: "deletedAt",
          align: "left",
          sortable: true,
        },
        {
          text: this.$t("labels.balance"),
          value: "balance",
          align: "left",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      search: null,
      refundDialog: false,
      selectedTask: null,
      customers: [],
      loading: true,
      page: 1,
      sortBy: "balance",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  async created() {
    this.getList();
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    getList() {
      return customerService
        .getAll({ deleted: true })
        .then((response) => {
          this.customers = response.data;
          this.loading = false;
          return response;
        })
        .catch((error) => {
          throw error;
        });
    },
    unDeletedCustomer(customer) {
      if (!this.checkRightStatus(39)) {
        this.$swal(
          "Delete Customer",
          "You are not allow to delete customer with balance.",
          "warning"
        );
        return false;
      }
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          customerService
            .recover(customer.id)
            .then((response) => {
              if (response.data) {
                this.$swal("Un-Delete!", "Customer was recover.", "success");
                this.getList();
              }
            })
            .catch((error) => {
              throw error;
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.deleted-customer-page {
  background: #f8fafc;
  min-height: 100vh;
}

.deleted-customer-card {
  border-radius: 20px;
  background: #ffffff;
  overflow: hidden;
}

.list-header {
  padding: 16px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title-wrap {
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 22px;
  font-weight: 900;
  color: #0f172a;
  line-height: 1.15;
}

.page-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 3px;
}

.filter-bar {
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
}

.search-field {
  max-width: 360px;
}

.deleted-customer-table {
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
}

.table-row:hover {
  background: #f8fafc;
}

@media (max-width: 600px) {
  .page-title {
    font-size: 20px;
  }

  .search-field {
    max-width: none;
    width: 100%;
  }

  .filter-bar {
    padding: 10px;
  }
}
</style>
